import { Popover, Space } from 'antd'
import CIMSBadge from '../../../CIMSBadge'
import { CIMSCollapseRecursiveCountExtraProps } from './types'
import { recursiveCountSum } from './utils'
import RecursiveCounts from './components/RecursiveCounts'
import { useEffect } from 'react'

function CIMSCollapseRecursiveCountExtra({
  count = 0,
  children,
  counts = [],
  type,
  onCountChange,
  extra,
  ...rest
}: CIMSCollapseRecursiveCountExtraProps) {
  const badgesSum = counts.reduce(
    (sum, badges) => sum + recursiveCountSum(badges),
    0
  )
  useEffect(() => {
    onCountChange?.(badgesSum + count)
    // don't include onCountChange
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [badgesSum, count])
  return (
    <Space size="small" align="center">
      {extra}
      {count + badgesSum > 0 && (
        <Popover
          content={
            <Space size="small" direction="vertical">
              <CIMSBadge {...rest} count={count}>
                {children}
              </CIMSBadge>
              {counts.map((badges) => (
                <RecursiveCounts {...badges} />
              ))}
            </Space>
          }
        >
          <CIMSBadge {...rest} count={badgesSum + count} />
        </Popover>
      )}
    </Space>
  )
}

export default CIMSCollapseRecursiveCountExtra
